import React from 'react';
import { SvgIconProps, SvgIcon } from '@material-ui/core';

export const CancelIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path transform="translate(2 2)" id="a" d="M10 0C4.47 0 0 4.47 0 10s4.47 10 10 10 10-4.47 10-10S15.53 0 10 0zm4.3 14.3a.996.996 0 0 1-1.41 0L10 11.41 7.11 14.3a.996.996 0 1 1-1.41-1.41L8.59 10 5.7 7.11A.996.996 0 1 1 7.11 5.7L10 8.59l2.89-2.89a.996.996 0 1 1 1.41 1.41L11.41 10l2.89 2.89c.38.38.38 1.02 0 1.41z" />
  </SvgIcon>
);
